exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-header-customer{display:inline-block;position:relative;margin-bottom:10px}.profile-header-customer img{padding:0}.profile-header-verified{height:30px;width:30px!important;border:3px solid #fff;background-color:#fff;border-radius:50%;position:absolute;bottom:5px;right:0}.profile-header-avatar{height:110px;width:110px!important;border:4px solid #fff;background-color:#fff;border-radius:50%;object-fit:cover}.myprofile-box{padding:50px!important;border-left:10px solid #c1282d}.h-30{height:30px}.profile-info .text-group{line-height:30px}.kyc-image img{width:230px;margin-top:30px}.up-button button{margin-top:40px;margin-bottom:5px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/pages/profile/component/profile.css
// module id = 1170
// module chunks = 0